/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createBookmark.defs.js'
export { main as default } from './createBookmark.defs.js'
